import * as React from 'react';
import { SOCIAL_LINKS } from '../../const';

const SocialLinks = () => {
  return (
    <div className="footer__social order-2 order-md-1">
      <p className="footer__social__title">Follow Us</p>
      <div className="footer__social__links d-flex">
        {SOCIAL_LINKS.map(({ site, url }, index) => {
          return (
            url && (
              <a key={`link-${site}-${index}`} href={url || ''} className={site} target="_blank">
                <div />
              </a>
            )
          );
        })}
      </div>
    </div>
  );
};

export default SocialLinks;



// WEBPACK FOOTER //
// ./src/components/Footer/components/SocialLinks/SocialLinks.tsx